import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables!')
  console.log('URL:', supabaseUrl)
  console.log('Key exists:', !!supabaseAnonKey)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
})

// export const supabasePublic = createClient(supabaseUrl, supabaseAnonKey, {
//   db: { schema: 'public' },
//   auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
// })
